import React from 'react';
import { UnorderedListOutlined, MailOutlined } from '@ant-design/icons';
import { Layout, Card, Form, Input, Button, message } from 'antd';

import { PWDREG, continueTest } from '@src/consts/regex';
import { getEmailCode, changePassword } from '@src/services/retrievePassword';

import './App.less';


const App = () => {
  const formRef = React.useRef(null);

  const onFinish = async (data) => {
    const res = await changePassword(data);

    if (res) {
      message.success('密码修改成功');
      formRef.current.resetFields();
    }
  };

  const onGetEmailCode = () => {
    formRef.current.validateFields(['email']).then(async (value) => {
      const res = await getEmailCode(value.email);

      if (res) {
        message.success('已成功发送验证码，有效期3分钟');
      };
    }).catch(() => { })
  }

  return (
    <div className="app">
      <Layout>
        <Layout.Header>
          <h1>环网登录方式在线找回子系统</h1>
        </Layout.Header>
        <Layout.Content>
          <div className='form_box'>
            <Card
              title={
                <>
                  <UnorderedListOutlined style={{ marginRight: 5 }} />
                  支持通过验证电子邮箱的方式找回
                </>
              }
              bordered={false}
            >
              <Form
                layout='vertical'
                ref={formRef}
                onFinish={onFinish}
              >
                <Form.Item
                  label="邮箱地址"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "请填写邮箱"
                    },
                    {
                      type: "email",
                      message: "请输入正确的邮箱格式"
                    }
                  ]}
                >
                  <Input
                    name="email"
                    addonBefore={<MailOutlined />}
                    addonAfter={
                      <span
                        className='btn'
                        onClick={onGetEmailCode}
                      >获取验证码</span>
                    }
                    placeholder="邮箱地址"
                  />
                </Form.Item>
                <Form.Item
                  label="验证码"
                  name="code"
                  rules={[
                    {
                      required: true,
                      message: "请输入验证码"
                    }
                  ]}
                >
                  <Input
                    name="code"
                    placeholder="验证码"
                  />
                </Form.Item>
                <Form.Item
                  label="请设置您的新密码"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "请输入您的新密码"
                    },
                    () => ({
                      validator(_, value) {
                        if (!continueTest(value)) {
                          return Promise.reject('密码中不能有连续的数字或字母');
                        };

                        if (!PWDREG.test(value)) {
                          return Promise.reject('密码最少11位字符（包含大小写字母+数字）')
                        };

                        return Promise.resolve();
                      }
                    })
                  ]}
                >
                  <Input.Password
                    name="password"
                    placeholder="请设置您的新密码"
                  />
                </Form.Item>
                <Form.Item
                  label="请再次输入您的新密码"
                  name="confirmPassword"
                  dependencies={['password']}
                  rules={[
                    {
                      required: true,
                      message: "重新输入新的密码"
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!continueTest(value)) {
                          return Promise.reject('密码中不能有连续的数字或字母');
                        };

                        if (getFieldValue().password !== value) {
                          return Promise.reject('新密码和确认密码应相同');
                        };

                        return Promise.resolve();
                      }
                    })
                  ]}
                >
                  <Input.Password
                    name="confirmPassword"
                    placeholder="请再次输入您的新密码"
                  />
                </Form.Item>
                <Button type="primary" htmlType="submit" style={{ marginTop: 15 }}>修改密码</Button>
              </Form>
            </Card>
          </div>
        </Layout.Content>
        <Layout.Footer>
          <p>2019-2022 © hw.powerchina-intl.com</p>
          <p>浏览器支持 360 ver:10+，谷歌，火狐</p>
        </Layout.Footer>
      </Layout>
    </div>
  );
}

export default App;
